export default {
  EBWC_BIG_WIN: 10,
  EBWC_MEGA_WIN: 20,
  EBWC_EPIC_WIN: 30,
}
